<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 5%;">
        <!--{{ 'WIZARD.PATRON.0.SECCION' | translate}}-->
        <ng-container *ngIf="cargando">
            <div fxLayout="column" fxLayoutAlign="space-between center">
                <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                <h1>{{'WIZARD.CT_INFORMACION.LISTA.CARGANDO' | translate}}</h1>
            </div>
        </ng-container>




        <ng-container *ngIf="!cargando">
            <ng-container *ngIf="estatusColaboraodres" [@animate]="{value:'*',params:{delay:'200ms', y:'125px'}}">
                <div class="statusDiv" fxLayout="row" fxLayoutAlign="center stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                    <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                        <h2>{{'WIZARD.CT_INFORMACION.LISTA.NODATA' | translate}}</h2>
                        <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="estadoCentro">
                <br>
                <div style="padding-bottom: 15px;">
                    <span>{{ 'WIZARD.DOCUMENTADOR.LABEL02' | translate}} <a href="https://www.gob.mx/stps/articulos/norma-oficial-mexicana-nom-035-stps-2018-factores-de-riesgo-psicosocial-en-el-trabajo-identificacion-analisis-y-prevencion">{{ 'WIZARD.DOCUMENTADOR.LABEL04' | translate}}</a> {{ 'WIZARD.DOCUMENTADOR.LABEL03' | translate}}</span>
                </div>

                <mat-accordion *ngFor="let tasklist of arrayTodoList; let k = index;" style="padding-top: 15px; padding-bottom: 3%; margin-top: 10px;">
                    <div style="padding-bottom: 1%;">
                        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="titulo">
                                    {{ArraySecciones[k] | translate }}: {{ArrayNum[k]}}
                                </mat-panel-title>
                                <mat-panel-description>

                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <table class="taskTables table table-striped table-bordered " style="margin-top: 1%; ">
                                <tbody>
                                    <!-- *ngFor="let tasklist of TaskListtmp " -->
                                    <tr *ngFor="let taskPrimary of tasklist.tareas ">
                                        <td style="text-align: justify; " class="tdDescrip col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                            {{taskPrimary.descripcion}}
                                        </td>
                                        <td style="text-align: left; word-break: break-all " class="tdFiles col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                            <mat-list role="list" *ngFor="let arch of taskPrimary.archivos; let i=index ">
                                                <mat-list-item role="listitem">
                                                    <p><a target="_blank " href="{{htp}}{{urlServidor}}/surveyadministrator/backend/{{arch.rutaArchivo}} ">{{arch.nombreArchivo}}</a></p>
                                                </mat-list-item>
                                            </mat-list>
                                            <!--<table class="fileTaskTabla ">
                                                <tr *ngFor="let arch of taskPrimary.archivos; let i=index " class="fileTaskTabla " style="height: 2px; ">
                                                    <td style="border: hidden; height: 1px; " class="fileTaskTabla ">
                                                        <p><a target="_blank " href="{{htp}}{{urlServidor}}/surveyadministrator/backend/{{arch.rutaArchivo}} ">{{arch.nombreArchivo}}</a></p>
                                                    </td>
                                                </tr>
                                            </table>-->
                                        </td>
                                        <td style="font-size: 14px; " class="tdBtn col-lg-3 col-md-4 col-sm-6 col-xs-12">
                                            <!--{{taskPrimary.observaciones}}-->

                                            <button mat-icon-button aria-label=" " routerLink="{{ArrayPath[k]}}">
                                                      Ver
                                                    </button>
                                            <!--<a target="_blank " href="{{this.rutaTmp}} ">Guía de referencia I</a>-->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </mat-expansion-panel>
                    </div>

                </mat-accordion>
            </ng-container>

            <ng-container *ngIf="ViewBetter">
                <div class="mt-20" fxLayout="row" fxLayoutAlign="center stretch">
                    <button mat-raised-button class="primary" (click)="sendChecked();" style="width: 30%;" [disabled]="bloquearEvio">
                      Enviar a verificación
                    </button>
                </div>
            </ng-container>




        </ng-container>






    </div><br><br>

</div>
<!-- / CENTER -->